<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" scrollable persistent max-width="90%">
      <v-card>
      
        <v-toolbar dark color="blue-grey">
          <v-icon medium>{{ title.icon }}</v-icon>
          <v-toolbar-title>{{ title.text }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text style="height: 500px;">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-md class="py-1">
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-text-field label="เลขที่หนังสือ" v-model="item.letterNo"></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field label="ชื่อประชุม/โครงการ/สัมมนา" v-model="item.name" :rules="[rules.required]" required></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-textarea
                    rows="2"
                    outline
                    v-model="item.objective"
                    label="เป้าหมายของโครงการ"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md12>
                  <v-textarea
                    rows="2"
                    outline
                    v-model="item.indicator"
                    label="ตัวชี้วัดของโครงการ"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md4>
                  <v-menu
                    ref="menuStartDate"
                    :close-on-content-click="false"
                    v-model="menuStartDate"
                    :nudge-right="40"
                    :return-value.sync="item.startDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :value="date(item.startDate)"
                      label="วันที่เริ่มต้น"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="item.startDate" @input="$refs.menuStartDate.save(item.startDate)" no-title locale="th-Th"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md4>
                  <v-menu
                    ref="menuEndDate"
                    :close-on-content-click="false"
                    v-model="menuEndDate"
                    :nudge-right="40"
                    :return-value.sync="item.endDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :value="date(item.endDate)"
                      label="วันที่สิ้นสุด"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="item.endDate" @input="$refs.menuEndDate.save(item.endDate)" no-title locale="th-Th"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md4>
                  <v-layout class="pt-1">
                    <v-currency-field 
                      label="จำนวนวัน" 
                      filled
                      v-model="item.days"
                      suffix="วัน"/>
                    <v-btn fab dark small color="green" class="pa-0" @click="addDate">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md12>
                  <v-card>
                    <v-card-title primary-title>
                      <span class="blue-grey--text"><strong>รายละเอียดวันและเวลา</strong></span>
                  </v-card-title>
                    <v-card-text v-for="(period,index) in item.activityPeriods" :key="index" class="pa-1">
                      <form-period :period.sync="period">
                        <v-layout>
                          <v-tooltip top>
                            <v-btn icon class="mx-0" slot="activator" @click="discardDate(index)">
                              <v-icon color="pink">delete</v-icon>
                            </v-btn>
                            <span>ลบข้อมูล</span>
                          </v-tooltip>
                        </v-layout>
                      </form-period>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md12>
                  <v-card>
                    <v-card-title primary-title>
                      <span class="blue-grey--text mr-3"><strong>จัดโดย</strong></span>
                        <v-radio-group v-model="isGen" row hide-details @change="item.isGen = isGen" :disabled="readOnly">
                          <v-radio label="สำนักงาน" :value="true"></v-radio>
                          <v-radio label="รายวิชา" :value="false"></v-radio>             
                        </v-radio-group>
                    </v-card-title>
                    <v-card-text class="pt-0" v-if="!item.isGen">
                      <v-card elevation="0">
                        <v-card-title primary-title class="py-0">
                          <span class="blue-grey--text"><strong>รายวิชาที่จัด</strong></span>
                          <v-spacer></v-spacer>
                          <v-btn fab dark small color="green" @click="addActiveCourse">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text v-for="(ac, index) in item.activeCourses" :key="index" class="pa-1">
                          <form-active-course :item.sync="ac" :academicYearItems="academicYearItems">
                            <v-layout>
                              <!-- <v-chip color="orange" text-color="white" @click="discardActiveCourse(index)">x</v-chip> -->
                              <v-tooltip top>
                                <v-btn icon class="mx-0" slot="activator" @click="discardActiveCourse(index)">
                                  <v-icon color="pink">delete</v-icon>
                                </v-btn>
                                <span>ลบข้อมูล</span>
                              </v-tooltip>
                            </v-layout>
                          </form-active-course>
                        </v-card-text>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md12>
                  <v-radio-group v-model="item.inside" row >
                    <v-radio label="จัดภายในมหาวิทยาลัย" :value="true"></v-radio>
                    <v-radio label="จัดภายนอกมหาวิทยาลัย" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field label="สถานที่" v-model="item.location" :rules="[rules.required]" required></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field label="ผู้รับผิดชอบโครงการ" v-model="item.organizer" :rules="[rules.required]" required></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-currency-field 
                    label="ประมาณการรายจ่าย" 
                    filled
                    v-model="item.budgetAmount"
                    suffix="บาท"/>
                </v-flex>
                <v-flex xs12 md6>
                  <v-currency-field 
                    label="ค่าใช้จ่าย(จ่ายจริง)" 
                    filled
                    v-model="item.expenseAmount"
                    suffix="บาท"/>
                </v-flex>
                <v-flex xs12 md12>
                  <v-autocomplete
                    :items="personItems"
                    v-model="item.participants"
                    label="ผู้เข้าร่วม (คณาจารย์/บุคลากร ภายในและภายนอก)"
                    item-value="id"
                    item-text="fullname"
                    return-object
                    multiple
                    chips
                    clearable
                    outline
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field label="ผู้เข้าร่วม (อื่นๆ)" v-model="item.other"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="จำนวนผู้เข้าร่วมทั้งหมด" 
                    filled
                    v-model="item.totalParticipants"
                    suffix="คน"
                    mask="###"/>
                </v-flex>
                <v-flex xs12 md12>
                  <v-autocomplete
                    :items="personItems"
                    v-model="item.guests"
                    label="วิทยากร"
                    item-value="id"
                    item-text="fullname"
                    return-object
                    multiple
                    chips
                    clearable
                    outline
                  ></v-autocomplete>
                </v-flex>
              </v-layout>  
              
              <v-layout wrap>
                <v-flex xs12 md6 v-if="item.documents">
                  <v-list subheader>
                    <v-subheader class="blue-grey--text"><strong>รายการเอกสารแนบ</strong></v-subheader>

                    <v-list-tile
                      v-for="(doc, index) in item.documents"
                      :key="doc.filename"
                      avatar
                      @click=""
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>
                        <a :href="download(doc)">{{doc.filename}}</a>
                      </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon ripple @click.native="onDeleteFile(doc, index)">
                          <v-icon color="grey lighten-1">delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs12 md12>
                  <div align="right">
                    <span class="grey--text caption"><strong>ประเภทไฟล์ที่สามารถอัพโหลด ได้แก่ .png, .jpg, .jpeg, .gif, .pdf, .xls, .xlsx, .doc, .docx | สูงสุด 3 ไฟล์ | ขนาดไฟล์แต่ละไฟล์ไม่เกิน 1MB</strong></span>
                  </div>
                  <vue-dropzone 
                    ref="myVueDropzone" 
                    id="dropzone" 
                    :options="dropzoneOptions" 
                    @vdropzone-file-added="fileAdded" 
                    @vdropzone-success="uploadSuccess" 
                    @vdropzone-removed-file="removeFile">
                  </vue-dropzone>
                </v-flex>
                <v-flex xs12 md12>
                  <v-textarea
                    rows="2"
                    outline
                    v-model="item.remark"
                    label="หมายเหตุ"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-5">
          <v-btn color="grey white--text" :loading="loading" :disabled="loading" @click.native="close">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" :disabled="loading" @click.native="onSubmit">บันทึก</v-btn>
        </v-card-actions>
        
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import vue2Dropzone from 'vue2-dropzone'
import swal from 'sweetalert2'
import FormActiveCourse from './formActiveCourse'
import FormPeriod from '../shared/formPeriod'

export default {
  props: ['dialog', 'item', 'title'],
  components: {
    FormActiveCourse,
    FormPeriod,
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      menuDate: false,
      loading: false,
      valid: false,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง',
        notEmpty: value => value.length > 0 || 'ไม่สามารถเป็นค่าว่าง',
        notNull: value => value === '' || 'ไม่สามารถเป็นค่าว่าง',
      },
      menuStartDate: false,
      menuEndDate: false,
      isGen: null,
      loadingAcademicYear: false,
      loadingActiveCourses: false,
      loadingSections: false,
      academicYear: null,
      activeCourse: null,
      courseType: null,
      courseTypeDisabled: true,
      academicYearItems: [],
      activeCourseItems: [],
      dropzoneOptions: {
        url: this.$store.getters['activityGen/uploadUrl'],
        headers: { 'Authorization': ['Bearer', this.$store.getters.token].join(' ') },
        method: 'post',
        autoProcessQueue: false,
        addRemoveLinks: true,
        createImageThumbnails: true,
        acceptedFiles: 'image/*, .doc, .docx, .xls, .xlsx, .pdf, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain',
        maxFiles: 3,
        uploadMultiple: true,
        parallelUploads: 3,
        maxFilesize: 1,
        params: {
          activityId: null
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      personItems: 'person/personItems',
      uploadUrl: 'activityGen/uploadUrl'
    }),
    readOnly () {
      return !! this.item.id 
    }
  },
  mounted () {
    this.$store.dispatch('person/fetchPersonItems')
    this.fetchAcademicYears ()
    this.isGen = this.item.isGen
  },
  methods: {
    date (val) {
      return val ? this.$options.filters.formatFullDate(val) : null
    },
    addActiveCourse (event) {
      let activeCourse = {
        academicYear: { id: null},
        id: null
      }
      this.item.activeCourses.push(activeCourse)
    },
    discardActiveCourse (idx) {
      // console.log('idx', idx)
      this.item.activeCourses.splice(idx, 1)
    },
    addDate (event) {
      this.item.activityPeriods.push({
        date: null,
        startTime: '',
        endTime: ''
      })
      this.item.days = this.item.activityPeriods.length
    },
    discardDate (idx) {
      this.item.activityPeriods.splice(idx, 1)
      this.item.days = this.item.activityPeriods.length
    },
    close: function() {
      this.$emit('dialog', false)
    },
    fileAdded (file) {
      console.log("fileAdded", file)
    },
    uploadSuccess (file, response) {
      console.log("uploadSuccess", response)
    },
    removeFile (file, error, xhr) {
      console.log("removeFile", file)
    },
    onSubmit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let dispatch = this.item.id && this.item.id > 0 ? 'activityGen/update' : 'activityGen/create'
        console.log('this.item.activityPeriods:', this.item.activityPeriods )
        this.$store.dispatch(dispatch, this.item)
          .then((response) => {
            // console.log('onSave:', response )
            this.dropzoneOptions.params.activityId = response.data.id
            console.log('activityId', this.dropzoneOptions.params.activityId)
            this.$refs.myVueDropzone.processQueue()
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    },
    download (doc) {
      return `${this.$store.getters['attachmentDocument/downloadUrl']}/${doc.id}?access_token=${this.$store.getters.token}`
    },
    onDeleteFile (doc, index) {
      // console.log('delete:', doc )
      // console.log('index:', index )
      const idx = this.item.documents.indexOf(doc)
      // console.log('idx:', idx )
      this.item.documents.splice(index, 1)
    },
    fetchAcademicYears () {
      this.loadingAcademicYear = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
          this.loadingAcademicYear = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingAcademicYear = false
        })
    }
  },
  watch: {
  }
}

</script>


// WEBPACK FOOTER //
// src/components/activity/gen/formDialog.vue